import {
  Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';
import { InsuranceFormOpenQuoteWrapper } from '@app/pages/quote/open-quote/deals/insurance-form/insurance-form-wrapper.component';

@Component({
  selector: 'app-insurance-form-mobile',
  templateUrl: './insurance-form-mobile.component.html',
  styleUrls: ['./insurance-form-mobile.component.scss'],
})
export class InsuranceFormMobileComponent extends InsuranceFormOpenQuoteWrapper {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
